import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { EmptyObject } from 'apollo-angular/types';
import { Apollo, MutationResult } from 'apollo-angular';
import { QueryRef } from 'apollo-angular/query-ref';
import { FetchResult, MutationOptions, WatchQueryOptions } from '@apollo/client/core';

@Injectable({
  providedIn: 'root',
})
export class EcapGql {
  constructor(private apollo: Apollo) {}

  watchQuery<T, V = EmptyObject>(options: WatchQueryOptions<V>): QueryRef<T, V> {
    return this.apollo.watchQuery(options);
  }

  mutate<T, V = EmptyObject>(options: MutationOptions<T, V>): Observable<MutationResult<T>> {
    return this.apollo.use('Mutations').mutate(options);
  }

  watchQueryCache<T, V = EmptyObject>(options: WatchQueryOptions<V>): QueryRef<T, V> {
    return this.apollo.use('QueryCache').watchQuery(options);
  }

  mutateCache<T, V = EmptyObject>(options: MutationOptions<T, V>): Observable<MutationResult<T>> {
    return this.apollo.use('MutationsCache').mutate(options);
  }
}
